module.exports = __webpack_public_path__ + "img/shulga-m.2198da06.jpg";